import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const theme = useTheme();
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        color: alpha(theme.palette.common.white, 0.85),

        '&:hover': {
          bgcolor:
            theme.palette.mode === 'light'
              ? alpha(theme.palette.common.white, 0.12)
              : alpha(theme.palette.common.white, 0.08),
        },

        '&.active': {
          color: theme.palette.common.white,
          fontWeight: theme.typography.fontWeightBold,
          bgcolor:
            theme.palette.mode === 'light'
              ? theme.palette.secondary.main
              : alpha(theme.palette.primary.main, 0.25),
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
